import React, {   useEffect, useState } from 'react';
import Layout from '../../component/layout/Layout';
import Card from '../../component/cards/Card';
import { getAllBlogsService } from '../../services/blogService';
import ClipLoader from "react-spinners/ClipLoader";


const Blog = () => {


 const [data,setData]=useState([]);
 const [loader,setLoader]=useState([]);
  const handleBlog=async()=>{
    setLoader(true)
    const response = await getAllBlogsService();
    if(response.status){
        setData(response.data);
        setLoader(false)
    }
  }
  useEffect(()=>{
    if(data.length===0){

      handleBlog();
    }
  },[data.length])
  return (
    <Layout>
        <div className="">
        <div className="bg-primary  py-10 w-full overflow-hidden ">
   <div className="container m-auto">
  <div className="">
    <div className="w-full px-4">
      <div className="text-center">
        <h1 className="font-semibold text-white text-4xl">Blog/News </h1>
      </div>
    </div>
  </div>
</div>
</div>
</div>
    <section className="py-5">
      <div className="container px-5 md:px-20 m-auto"> 
        {loader ?
        <div className='flex items-center justify-center'>
      <ClipLoader
        color={"#333"}
        loading={loader}
        // cssOverride={override}
        size={150}
        className="relative top-1 left-2"
        aria-label="Loading "
        data-testid="loader"
      />
      </div>
      :
        <div className="flex flex-wrap ">
          {data?.map((post, index) => (
          <Card key={index} index={index} post={post} />
          ))}

        </div>
}
      </div>
    </section>
    </Layout>
  );
};

export default Blog;
